import { render, staticRenderFns } from "./VersionsDataTable.vue?vue&type=template&id=d07d1e62&"
import script from "./VersionsDataTable.vue?vue&type=script&lang=js&"
export * from "./VersionsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports